import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateTenantSmsPacing } from 'services/api/AccessManagerAPI';
import { queryKeys } from '../queryKeys';

// Super admin only. Refetches the tenant's SMS pacing on success so the editor
// re-renders with isDefault and the server-chosen value (the server returns
// the resolved shape rather than a copy of the input).
export const useUpdateTenantSmsPacing = () => {
    const queryClient = useQueryClient();
    const { mutateAsync, isPending } = useMutation({
        mutationFn: updateTenantSmsPacing,
        // The endpoint validates and 400s on bad input; a retry just doubles
        // the failure.
        retry: 0,
        onSuccess: (_data, { id }) => {
            queryClient.invalidateQueries({ queryKey: queryKeys.tenantSmsPacing(id) });
        },
    });

    return { updateTenantSmsPacing: mutateAsync, isPending };
};
